/* lua.js generated code 0.3.0 */

require("clover/config/level/MapData")
let { getLevelGuideResList, getLevelUsedGuideResList } = require('./GuideResConfig.js')

LevelConfig = xClass("LevelConfig")
LevelConfig.prototype.ctor = function () {
    let __VA_ARG = $slice(arguments, 0)
    var self = this
    // body
    self.gameMode = ""
    self.numberOfColors = 6
    self.scoreTargets = table(
        10000,
        20000,
        30000
    )
    self.randomSeed = 0
    self.level = 1
    self.props = null
    self.ingamePropTypes = null
    self.moveLimit = 0
    self.waterBombRound = 0
    self.timeLimit = -1
    self.layerAmount = 0
    self.clearTargetLayers = 5
    self.addMoveBase = GamePlayConfig_Add_Move_Base
    self.replaceColorMaxNum = 0
    self.furballMoveMin = 0
    self.furballMoveMax = 0
    self.mapDatas = table()
    self.variousBoxSeed = 0
    self.useDropStable = 0
    self.bonusMoreColor = 0

}
LevelConfig.prototype.initWithData = function (id, data) {
    var self = this
    // body
    self.id = id
    self.version = data.version
    self.gameMode = data.gameMode
    self.numberOfColors = data.colors
    self.scoreTargets = data.scoreTargets
    self.randomSeed = data.randomSeed
    self.props = data.props
    self.ingamePropTypes = data.ingamePropsType
    self.moveLimit = data.moveLimit
    self.timeLimit = data.timeLimit || 0
    self.targetNumThreshold = data.targetNumThreshold || 0  // 限时挑战
    self.extraAddTime = data.extraAddTime || 0  // 限时挑战
    self.waterBombRound = data.waterBombRound || 0
    self.replaceColorMaxNum = data.replaceColorMaxNum || 0
    self.furballMoveMin = data.furballMin || 1
    self.furballMoveMax = data.furballMax || 1
    self.addMoveBase = data.addMoveBase || GamePlayConfig_Add_Move_Base
    self.variousBoxSeed = data.variousBoxSeed
    self.useDropStable = tonumber(data.useDropStable) || 0
    if (data.isFriendPvp){
        // 友谊赛
        self.isFriendPvp = data.isFriendPvp;
    }else{
        self.isFriendPvp = false;
    }
    self.bonusMoreColor = data.bonusMoreColor
    self.initMapDatas(data)
}
LevelConfig.prototype.initMapDatas = function (data) {
    let self = this
    // body
    if (data.childLevel) {
        for (let k = 1, v = data.childLevel[1]; v; k++ , v = data.childLevel[k]) {
            let map = self.createChildData(data.gameMode, data.gameModeInPvp)
            map.initWithData(v)
            self.mapDatas[k] = map
        }
    } else { //---兼容老版本
        let map = self.createChildData(data.gameMode, data.gameModeInPvp)
        map.initWithData(data)
        self.mapDatas[1] = map
    }
}
LevelConfig.prototype.getMapDataByIndex = function (index) {
    let self = this
    // body
    return self.mapDatas[index]
}
LevelConfig.prototype.getChildrenMapCount = function () {
    let __VA_ARG = $slice(arguments, 0)
    let self = this
    // body
    return $len(self.mapDatas)
}
LevelConfig.prototype.createChildData = function (gameMode, gameModeInPvp) {
    let self = this
    // body
    // if (gameMode === GamePlayType.kOrder || gameMode === GamePlayType.kUnionWar) {
    if (gameMode === GamePlayType.kOrder) {
        // WARN: maybe multi result
        return OrderMapData.create()
    } else if (gameMode === GamePlayType.kIce) {
        // WARN: maybe multi result
        return IceMapData.create()
    } else if (gameMode === GamePlayType.kBlockLight) {
        // WARN: maybe multi result
        return OrderMapData.create()
    } else if (gameMode === GamePlayType.kFish || gameMode === GamePlayType.kProtectFish) {
        // WARN: maybe multi result
        return FishMapData.create()
    } else if (gameMode === GamePlayType.kBoss) {
        // WARN: maybe multi result
        return BossMapData.create()
    } else if (gameMode === GamePlayType.kBlockCollection) {
        // WARN: maybe multi result
        var mapData = BlockCollectionMapData.create();
        // 限时挑战的目标面板增加了秒表
        if (LevelType.getLevelTypeByLevelId(self.id) === GamePlayType.kTimeBlockCollection){
            mapData.needAimLimit();
        }
        return mapData
    } else if (gameMode === GamePlayType.kDropDig) {
        // WARN: maybe multi result
        return DropDigMapData.create()
    } else if (gameMode === GamePlayType.kWaterDig) {
        // WARN: maybe multi result
        return WaterDigMapData.create()
    } else if (gameMode === GamePlayType.kPursue) {
        // WARN: maybe multi result
        return PursueMapData.create()
    } else if (gameMode === GamePlayType.kPvp) {
        if (self.isFriendPvp){
            cc.log("---------gameModeInPvp--------", gameModeInPvp)
            if (gameModeInPvp === GamePlayType.kOrder) {
                return OrderMapData.create()
            } else if (gameModeInPvp === GamePlayType.kIce) {
                return IceMapData.create()
            } else if (gameModeInPvp === GamePlayType.kFish) {
                return FishMapData.create()
            } else if (gameModeInPvp === GamePlayType.kBoss) {
                return BossMapData.create()
            } else if (gameModeInPvp === GamePlayType.kBlockCollection) {
                var mapData = BlockCollectionMapData.create();
                // 限时挑战的目标面板增加了秒表
                if (LevelType.getLevelTypeByLevelId(self.id) === GamePlayType.kTimeBlockCollection){
                    mapData.needAimLimit();
                }
                return mapData
            } else if (gameModeInPvp === GamePlayType.kWaterDig) {
                return WaterDigMapData.create()
            } else if (gameModeInPvp === GamePlayType.kPursue) {
                return PursueMapData.create()
            }
        }else{
            return PvpMapData.create()
        }
        
    } else if (gameMode === GamePlayType.kOneStep) {
        return OneStepMapData.create()
    } else if (gameMode === GamePlayType.kTimeBlockCollection) {
        return TimeBlockCollectionMapData.create()
    } else if (gameMode === GamePlayType.kGold) {
        // WARN: maybe multi result
        return GoldMapData.create()
    } else {
        // WARN: maybe multi result
        return BaseMapData.create()
    }
}
LevelConfig.prototype.dispose = function () { }
LevelConfig.prototype.getDependingSpecialAssetsList = function (levelType, otherData) {
    let self = this
    let resNameMap = table()
    for (let k = 1, v = ResourceConfig.levelExtPng[1]; v; k++ , v = ResourceConfig.levelExtPng[k]) {
        resNameMap[v] = true
    }

    for (let k = 1, v = ResourceConfig.levelExtPlist[1]; v; k++ , v = ResourceConfig.levelExtPlist[k]) {
        resNameMap[v] = true
    }
    for (let k = 1, v = ResourceConfig.levelExtCsb[1]; v; k++ , v = ResourceConfig.levelExtCsb[k]) {
        resNameMap[v] = true
    }
    for (let k = 1, v = ResourceConfig.levelExtFnt[1]; v; k++ , v = ResourceConfig.levelExtFnt[k]) {
        resNameMap[v] = true
    }

    let aniPrefillClazzs = table()
    for (let k = 1, v = self.mapDatas[1]; v; k++ , v = self.mapDatas[k]) {
        if (otherData && otherData.isFriendPvp){
            v.addMapNeedAssets(resNameMap, self.gameModeInPvp, true);
        }else{
            v.addMapNeedAssets(resNameMap, levelType);
        }
        v.addPrefillAnimationClazz(aniPrefillClazzs, self.gameMode)
    }

    if (_G.isOHOS){
        // 部分资源引用了不相关的资源导致鸿蒙上卡死，所以强制加了部分资源
        resNameMap["cocos/clover_animation_fish.plist"] = true
        resNameMap["cocos/clover_animation_octopus.plist"] = true
        resNameMap["cocos/level_difficulty.plist"] = true
    }

    // guide res
    getLevelGuideResList(this.id).forEach(r => r && (resNameMap[r] = true))

    var result = table()
    for (var resName in resNameMap) {
        let v = resNameMap[resName]
        if ($null(v)) continue
        table.insert(result, resName)
    }

    let prefills = table()
    if (aniPrefillClazzs && aniPrefillClazzs.classDefines)
    {
        for (let i = 0; i < aniPrefillClazzs.classDefines.length; i++) {
            let v = aniPrefillClazzs.classDefines[i]
            if ($null(v)) continue
            table.insert(prefills, v)
        }
    }

    return [result, prefills]
}

LevelConfig.prototype.getNeedMusics = function (levelType) {
    let self = this
    for (let k = 1, v = self.mapDatas[1]; v; k++ , v = self.mapDatas[k]) {
        // WARN: maybe multi result
        return v.getNeedMusics(levelType)
    }
    return table()
}
